export const SIDE_MENU_TOGGLE = 'SIDE_MENU_TOGGLE'
